module.exports = __webpack_public_path__ + "img/asanmobile2.6f074e3e.jpeg";